import { inject, provideEnvironmentInitializer, Provider } from '@angular/core';
import {
  provideSoftAppsRoutes,
  SOFTLINE_CONFIG_FIELD_OK_SEARCH_PAGE,
} from '@softapps/core';
import { SOFTLINE_CONFIG_FIELD_OK } from '@softline/dynamic';
import {
  SOFTLINE_FEATURE_TRANSLATION,
  SOFTLINE_ICONS,
  TranslationStore,
} from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { artikelProviders } from './artikel/artikel.providers';
import { einheiteneingabeProviders } from './einheiteneingabe/einheiteneingabe.providers';
import { abcanalyseFieldOk } from './field-ok/abcanalyse/abcanalyse.field-ok';
import {
  abteilungFieldOk,
  abteilungMultiselectFieldOk,
  abteilungQueryFieldOk,
} from './field-ok/abteilung/abteilung.field-ok';
import {
  abteilungsubFieldOk,
  abteilungsubMultiselectFieldOk,
  abteilungsubQueryFieldOk,
} from './field-ok/abteilungsub/abteilungsub.field-ok';
import {
  artehFieldOk,
  artehMultiselectFieldOk,
  artehQueryFieldOk,
} from './field-ok/arteh/arteh.field-ok';
import {
  arthauptgrpFieldOk,
  arthauptgrpMultiselectFieldOk,
  arthauptgrpQueryFieldOk,
} from './field-ok/arthauptgrp/arthauptgrp.field-ok';
import {
  artikelkz7FieldOk,
  artikelkz7MultiselectFieldOk,
  artikelkz7QueryFieldOk,
} from './field-ok/artikelkz7/artikelkz7.field-ok';
import {
  artstammFieldOk,
  artstammMultiselectFieldOk,
  artstammQueryFieldOk,
  artstammSearchPageConfig,
} from './field-ok/artstamm/artstamm.field-ok';
import {
  artuntergrpFieldOk,
  artuntergrpMultiselectFieldOk,
  artuntergrpQueryFieldOk,
} from './field-ok/artuntergrp/artuntergrp.field-ok';
import {
  artunteruntergrpFieldOk,
  artunteruntergrpMultiselectFieldOk,
  artunteruntergrpQueryFieldOk,
} from './field-ok/artunteruntergrp/artunteruntergrp.field-ok';
import {
  auftragFieldOk,
  auftragMultiselectFieldOk,
  auftragQueryFieldOk,
} from './field-ok/auftrag/auftrag.field-ok';
import {
  chargeFieldOk,
  chargeMultiselectFieldOk,
  chargeQueryFieldOk,
} from './field-ok/charge/charge.field-ok';
import {
  ekorgFieldOk,
  ekorgMultiselectFieldOk,
  ekorgQueryFieldOk,
} from './field-ok/ekorg/ekorg.field-ok';
import {
  faelldtFieldOk,
  faelldtMultiselectFieldOk,
  faelldtQueryFieldOk,
} from './field-ok/faelldt/faelldt.field-ok';
import {
  fahrzeugFieldOk,
  fahrzeugMultiselectFieldOk,
  fahrzeugQueryFieldOk,
} from './field-ok/fahrzeug/fahrzeug.field-ok';
import {
  fahrzeugtypFieldOk,
  fahrzeugtypMultiselectFieldOk,
  fahrzeugtypQueryFieldOk,
} from './field-ok/fahrzeugtyp/fahrzeugtyp.field-ok';
import {
  fahrzeugverwendungsbestimmungFieldOk,
  fahrzeugverwendungsbestimmungMultiselectFieldOk,
  fahrzeugverwendungsbestimmungQueryFieldOk,
} from './field-ok/fahrzeugverwendungsbestimmung/fahrzeugverwendungsbestimmung.field-ok';
import {
  fehlerartFieldOk,
  fehlerartMultiselectFieldOk,
  fehlerartQueryFieldOk,
} from './field-ok/fehlerart/fehlerart.field-ok';
import {
  fibperFieldOk,
  fibperMultiselectFieldOk,
  fibperQueryFieldOk,
} from './field-ok/fibper/fibper.field-ok';
import {
  fzhauptklasseFieldOk,
  fzhauptklasseMultiselectFieldOk,
  fzhauptklasseQueryFieldOk,
} from './field-ok/fzhauptklasse/fzhauptklasse.field-ok';
import {
  fzunterklasseFieldOk,
  fzunterklasseMultiselectFieldOk,
  fzunterklasseQueryFieldOk,
} from './field-ok/fzunterklasse/fzunterklasse.field-ok';
import {
  kasseFieldOk,
  kasseMultiselectFieldOk,
  kasseQueryFieldOk,
} from './field-ok/kasse/kasse.field-ok';
import {
  kassiererFieldOk,
  kassiererMultiselectFieldOk,
  kassiererQueryFieldOk,
} from './field-ok/kassierer/kassierer.field-ok';
import {
  kondgruppeFieldOk,
  kondgruppeMultiSelectFieldOk,
  kondgruppeQueryFieldOk,
} from './field-ok/kondgruppe/kondgruppe.field-ok';
import {
  kostenstelleFieldOk,
  kostenstelleMultiselectFieldOk,
  kostenstelleQueryFieldOk,
} from './field-ok/kostenstelle/kostenstelle.field-ok';
import {
  ktostammKundeSubnummerFieldOk,
  ktostammKundeSubnummerMultiselectFieldOk,
  ktostammKundeSubnummerQueryFieldOk,
  ktostammKundeSubnummerSearchPageConfig,
} from './field-ok/ktostamm-kunde-subnummer/ktostamm-kunde-subnummer.field-ok';
import {
  ktostammKundeFieldOk,
  ktostammKundeMultiselectFieldOk,
  ktostammKundeQueryFieldOk,
  ktostammKundeSearchPageConfig,
} from './field-ok/ktostamm-kunde/ktostamm-kunde.field-ok';
import {
  ktostammLieferantFieldOk,
  ktostammLieferantMultiselectFieldOk,
  ktostammLieferantQueryFieldOk,
  ktostammLieferantSearchPageConfig,
} from './field-ok/ktostamm-lieferant/ktostamm-lieferant.field-ok';
import {
  kundengruppeKundengrpFieldOk,
  kundengruppeKundengrpMultiSelectFieldOk,
  kundengruppeKundengrpQueryFieldOk,
} from './field-ok/kundengruppe-kundengrp/kundengruppe-kundengrp.field-ok';
import {
  kundeslaFieldOk,
  kundeslaMultiselectFieldOk,
  kundeslaQueryFieldOk,
} from './field-ok/kundesla/kundesla.field-ok';
import {
  lagerLagerplatzFieldOk,
  lagerLagerplatzMultiselectFieldOk,
  lagerLagerplatzQueryFieldOk,
  lagerLagerplatzSearchPageConfig,
} from './field-ok/lager-lagerplatz/lager-lagerplatz.field-ok';
import {
  lagerortFieldOk,
  lagerortMultiselectFieldOk,
  lagerortQueryFieldOk,
} from './field-ok/lagerort/lagerort.field-ok';
import {
  lagerstammFieldOk,
  lagerstammMultiselectFieldOk,
  lagerstammQueryFieldOk,
} from './field-ok/lagerstamm/lagerstamm.field-ok';
import { lagersymSearchPageConfig } from './field-ok/lagersym/lagersym.field-ok';
import {
  landeskennzeichenFieldOk,
  landeskennzeichenMultiselectFieldOk,
  landeskennzeichenQueryFieldOk,
  landeskennzeichenSearchPageConfig,
} from './field-ok/landeskennzeichen/landeskennzeichen.field-ok';
import {
  lstfixFieldOk,
  lstfixFieldOkMultiselectFieldOk,
  lstfixQueryFieldOk,
} from './field-ok/lstfix/lstfix.field-ok';
import {
  maschineFieldOk,
  maschineMultiselectFieldOk,
  maschineQueryFieldOk,
} from './field-ok/maschine/maschine.field-ok';
import {
  objektFieldOk,
  objektMultiselectFieldOk,
  objektQueryFieldOk,
  objektSearchPageConfig,
} from './field-ok/objekt/objekt.field-ok';
import {
  orteFieldOk,
  orteMultiselectFieldOk,
  orteQueryFieldOk,
} from './field-ok/orte/orte.field-ok';
import {
  pickerltypFieldOk,
  pickerltypMultiselectFieldOk,
  pickerltypQueryFieldOk,
} from './field-ok/pickerltyp/pickerltyp.field-ok';
import {
  plangruppeFieldOk,
  plangruppeMultiselectFieldOk,
  plangruppeQueryFieldOk,
} from './field-ok/plangruppe/plangruppe.field-ok';
import {
  produktgruppeFieldOk,
  produktgruppeMultiselectFieldOk,
  produktgruppeQueryFieldOk,
} from './field-ok/produktgruppe/produktgruppe.field-ok';
import {
  ticketcobitkatFieldOk,
  ticketcobitkatMultiselectFieldOk,
  ticketcobitkatQueryFieldOk,
} from './field-ok/ticketcobitkat/ticketcobitkat.field-ok';
import {
  verkaufsartwerkstattFieldOk,
  verkaufsartwerkstattMultiselectFieldOk,
  verkaufsartwerkstattQueryFieldOk,
} from './field-ok/verkaufsartwerkstatt/verkaufsartwerkstatt.field-ok';
import {
  vertreterFieldOk,
  vertreterMultiselectFieldOk,
  vertreterQueryFieldOk,
} from './field-ok/vertreter/vertreter.field-ok';
import {
  vkforgFieldOk,
  vkforgMultiselectFieldOk,
  vkforgQueryFieldOk,
} from './field-ok/vkforg/vkforg.field-ok';
import {
  wtaetigkeitFieldOk,
  wtaetigkeitMultiselectFieldOk,
  wtaetigkeitQueryFieldOk,
} from './field-ok/wtaetigkeit/wtaetigkeit.field-ok';
import {
  zahlartkassaFieldOk,
  zahlartkassaMultiselectFieldOk,
  zahlartkassaQueryFieldOk,
} from './field-ok/zahlartkassa/zahlartkassa.field-ok';
import {
  zbewegungsartFieldOk,
  zbewegungsartMultiselectFieldOk,
  zbewegungsartQueryFieldOk,
} from './field-ok/zbewegungsart/zbewegungsart.field-ok';
import { Store } from '@softline/core';
import {
  seriennrFieldOk,
  seriennrMultiselectFieldOk,
  seriennrQueryFieldOk,
} from './field-ok/seriennr/seriennr.field-ok';

export const wwsCoreProviders = [
  ...artikelProviders,
  ...einheiteneingabeProviders,
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: abcanalyseFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: abteilungFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: abteilungMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: abteilungQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: abteilungsubFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: abteilungsubMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: abteilungsubQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: artehFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: artehMultiselectFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: artehQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: seriennrFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: seriennrMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: seriennrQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: arthauptgrpFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: arthauptgrpMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: arthauptgrpQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: artuntergrpFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: artuntergrpMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: artuntergrpQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: artunteruntergrpFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: artunteruntergrpMultiselectFieldOk,
  },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: artunteruntergrpQueryFieldOk,
  },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: fahrzeugFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: fahrzeugMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: fahrzeugQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: fahrzeugtypFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: fahrzeugtypMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: fahrzeugtypQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: artunteruntergrpFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: fahrzeugverwendungsbestimmungFieldOk,
  },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: fahrzeugverwendungsbestimmungMultiselectFieldOk,
  },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: fahrzeugFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: fahrzeugverwendungsbestimmungQueryFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: fahrzeugQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: ktostammKundeFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: ktostammKundeMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: ktostammKundeQueryFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK_SEARCH_PAGE,
    multi: true,
    useValue: ktostammKundeSearchPageConfig,
  },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: objektFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: objektMultiselectFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: objektQueryFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK_SEARCH_PAGE,
    multi: true,
    useValue: objektSearchPageConfig,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: kasseFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: kasseMultiselectFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: kasseQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: zahlartkassaFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: zahlartkassaMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: zahlartkassaQueryFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: kassiererFieldOk,
  },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: kassiererMultiselectFieldOk,
  },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: kassiererQueryFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: objektFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: objektMultiselectFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: objektQueryFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK_SEARCH_PAGE,
    multi: true,
    useValue: objektSearchPageConfig,
  },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: kostenstelleFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: kostenstelleMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: kostenstelleQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: landeskennzeichenFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: landeskennzeichenMultiselectFieldOk,
  },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: landeskennzeichenQueryFieldOk,
  },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK_SEARCH_PAGE,
    multi: true,
    useValue: landeskennzeichenSearchPageConfig,
  },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: orteFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: orteMultiselectFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: orteQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: pickerltypFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: pickerltypMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: pickerltypQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: vkforgFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: vkforgMultiselectFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: vkforgQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: ekorgFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: ekorgMultiselectFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: ekorgQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: faelldtFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: faelldtMultiselectFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: faelldtQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: zbewegungsartFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: zbewegungsartMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: zbewegungsartQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: wtaetigkeitFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: wtaetigkeitMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: wtaetigkeitQueryFieldOk },

  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: verkaufsartwerkstattFieldOk,
  },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: verkaufsartwerkstattMultiselectFieldOk,
  },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: verkaufsartwerkstattQueryFieldOk,
  },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: vertreterFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: vertreterMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: vertreterQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: lagerortFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: lagerortMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: lagerortQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: lagerstammFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: lagerstammMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: lagerstammQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: maschineFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: maschineMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: maschineQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: fibperFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: fibperMultiselectFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: fibperQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: fzhauptklasseFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: fzhauptklasseMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: fzhauptklasseQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: fzunterklasseFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: fzunterklasseMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: fzunterklasseQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: lagerLagerplatzFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: lagerLagerplatzMultiselectFieldOk,
  },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: lagerLagerplatzQueryFieldOk,
  },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK_SEARCH_PAGE,
    multi: true,
    useValue: lagerLagerplatzSearchPageConfig,
  },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: chargeFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: chargeMultiselectFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: chargeQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: artstammFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: artstammMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: artstammQueryFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK_SEARCH_PAGE,
    multi: true,
    useValue: artstammSearchPageConfig,
  },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: ktostammLieferantFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: ktostammLieferantMultiselectFieldOk,
  },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: ktostammLieferantQueryFieldOk,
  },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK_SEARCH_PAGE,
    multi: true,
    useValue: ktostammLieferantSearchPageConfig,
  },

  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: ktostammKundeSubnummerFieldOk,
  },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: ktostammKundeSubnummerMultiselectFieldOk,
  },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: ktostammKundeSubnummerQueryFieldOk,
  },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK_SEARCH_PAGE,
    multi: true,
    useValue: ktostammKundeSubnummerSearchPageConfig,
  },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: kundeslaFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: kundeslaMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: kundeslaQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: ticketcobitkatFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: ticketcobitkatMultiselectFieldOk,
  },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: ticketcobitkatQueryFieldOk,
  },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: fehlerartFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: fehlerartMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: fehlerartQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: auftragFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: auftragMultiselectFieldOk },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: auftragQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: lstfixFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: lstfixFieldOkMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: lstfixQueryFieldOk },

  {
    provide: SOFTLINE_CONFIG_FIELD_OK_SEARCH_PAGE,
    multi: true,
    useValue: lagersymSearchPageConfig,
  },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: plangruppeFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: plangruppeMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: plangruppeQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: produktgruppeFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: produktgruppeMultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: produktgruppeQueryFieldOk },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: kondgruppeFieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: kondgruppeMultiSelectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: kondgruppeQueryFieldOk },

  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: kundengruppeKundengrpFieldOk,
  },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: kundengruppeKundengrpMultiSelectFieldOk,
  },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: kundengruppeKundengrpQueryFieldOk,
  },

  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: artikelkz7FieldOk },
  {
    provide: SOFTLINE_CONFIG_FIELD_OK,
    multi: true,
    useValue: artikelkz7MultiselectFieldOk,
  },
  { provide: SOFTLINE_CONFIG_FIELD_OK, multi: true, useValue: artikelkz7QueryFieldOk },

  {
    provide: SOFTLINE_ICONS,
    multi: true,
    useValue: { name: 'soft-branch', icon: 'fa-regular fa-building' },
  },
  {
    provide: SOFTLINE_ICONS,
    multi: true,
    useValue: {
      name: 'soft-product-main-group',
      class: '!inline',
      icons: [
        'fa-regular fa-rectangle-barcode',
        'fa-regular fa-layer-group !bg-white text-[0.5em] absolute bottom-0 right-0 pl-[2px]',
      ],
    },
  },
  {
    provide: SOFTLINE_ICONS,
    multi: true,
    useValue: {
      name: 'soft-product-group',
      class: '!inline',
      icons: [
        'fa-regular fa-rectangle-barcode',
        'fa-regular fa-folder-open !bg-white text-[0.5em] absolute bottom-0 right-0 pl-[1px]',
      ],
    },
  },
  {
    provide: SOFTLINE_ICONS,
    multi: true,
    useValue: {
      name: 'soft-product-sub-group',
      class: '!inline',
      icons: [
        'fa-regular fa-rectangle-barcode',
        'fa-regular fa-square-dashed !bg-white text-[0.5em] absolute bottom-0 right-0 pl-[2px]',
      ],
    },
  },
  {
    provide: SOFTLINE_ICONS,
    multi: true,
    useValue: {
      name: 'soft-product',
      icon: 'fa-regular fa-rectangle-barcode',
    },
  },
  {
    provide: SOFTLINE_ICONS,
    multi: true,
    useValue: {
      name: 'soft-customer',
      icon: 'fa-regular fa-user-tie',
    },
  },

  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'wws-core',
      language: 'de',
      translations: de,
    });
  }),
];

export const wwsCoreEmbeddingProviders = [
  provideSoftAppsRoutes({
    embedded: [
      {
        path: 'product-search',
        providers: [],
        loadComponent: () => import('./product/search/product-search.component'),
      },
    ],
  }),
] satisfies Provider[];

export interface WwsCoreFeature {
  kind: 'EMBEDDING';
}

export function withEmbedding(): WwsCoreFeature {
  return {
    kind: 'EMBEDDING',
  };
}

export function provideWwsCore(...features: WwsCoreFeature[]): Provider[] {
  const providers = wwsCoreProviders as Provider[];

  for (const feature of features) {
    switch (feature.kind) {
      case 'EMBEDDING':
        providers.push(...wwsCoreEmbeddingProviders);
    }
  }

  return providers;
}
